module.exports = __webpack_public_path__ + "static/media/jnvs.c1ec04fe.jpeg";